<template>
    <div class="pageContainer app-container">
        <el-row class="flexStart">
            <el-button size="small" icon="el-icon-plus" @click="showRole" type="success" plain>关联部门角色</el-button>
            <el-popconfirm
                width="250"
                confirmButtonText='确定'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                @confirm="mutiDel"
                title="是否确定删除？">
                <el-button slot="reference" size="small" icon="el-icon-delete" type="danger" style="margin-left: 10px;">删除</el-button>
            </el-popconfirm>
        </el-row>
        <el-row type="flex" :gutter="16" style="margin-top: 20px">
            <el-col :span="6">
                <div class="treeContainer">
                    <div class="treeTitle">部门</div>
                    <el-tree
                        :data="treeData"
                        :props="treeProps"
                        :default-expand-all="true"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClick">
                    </el-tree>
                </div>
            </el-col>
            <el-col :span="18" class="tabContainer">
                <el-tabs v-model="activeName" type="border-card">
                    <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
                        <el-table
                            :data="tableData"
                            style="width: 100%;margin-bottom: 20px;"
                            border stripe @selection-change="handleSelectionChange">
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column prop="username" label="教师姓名"></el-table-column>
<!--                            <el-table-column prop="ucode" label="工号"></el-table-column>-->
                            <el-table-column prop="phone" label="手机号"></el-table-column>
                            <el-table-column prop="sort" label="排序"></el-table-column>
                            <el-table-column
                                fixed="right"
                                label="操作"
                                width="160">
                                <template slot-scope="scope">
                                    <el-popconfirm
                                        width="250"
                                        confirmButtonText='确定'
                                        cancelButtonText='取消'
                                        icon="el-icon-info"
                                        iconColor="red"
                                        @confirm="handleDel(scope.row)"
                                        placement="left"
                                        title="是否确定删除？">
                                        <a slot="reference" size="small"
                                           style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
                                    </el-popconfirm>
                                    <el-button @click="handleModify(scope.row)" type="text" size="small">修改</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
        <el-dialog :title="modalTitle" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true">
            <el-form :model="formData" ref="adminUserInfo" label-width="120px"
                     style="max-height: 450px;overflow-y: auto;min-height: 300px;">
                <el-form-item label="姓名" prop="username">{{formData.username}}</el-form-item>
                <el-form-item label="手机号" prop="phone">{{formData.phone}}</el-form-item>
                <el-form-item label="排序号">
                    <el-input v-model.trim="formData.sort" style="width: 50%"/>
                </el-form-item>
                <el-row v-for="(item,index) in formData.depts" :key="index"
                        class="flexStart" style="display: flex!important;">
                    <el-form-item :label="'所属部门'+(index+1)" prop="dept_id">
                        <el-cascader ref="firstCascader" :options="treeData"
                                     :props="firstCascaderProps"
                                     v-model="item.dept_id"
                                     :show-all-levels="false"
                                     @change="handleCascaderChange"
                                     placeholder="请选择"
                                     clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="部门角色" prop="item_desc">
                        <el-select v-model="item.role_id" placeholder="请选择角色">
                            <el-option v-for="(item1,index1) in roleList" :key="index1"
                                       :label="item1.role_name" :value="item1.id">{{item1.role_name}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-button size="small" @click="delDept(index)" type="danger" plain
                    style="margin-left: 10px;margin-bottom: 24px;">删除</el-button>

                </el-row>
                <el-row class="flexStart">
                    <el-form-item label="">
                        <el-button size="small" icon="el-icon-plus" @click="addDept" type="primary" plain>添加所属部门</el-button>

                    </el-form-item>
                </el-row>
              
            </el-form>
            <el-row>
                <el-col :span="22" style="text-align: right;">
                    <el-button size="small" type="default" @click="isShowModal = false">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('adminUserInfo')">保存</el-button>
                </el-col>
            </el-row>
        </el-dialog>
    
        <DeptRole ref="visiable_role"
                  :editOptions="editRole"
                  @saveRole="saveRole"></DeptRole>
    </div>
</template>
<script>
	import api from '@/api/api';
	import DeptRole from './components/DeptRole'
	export default {
		name: 'Menu',
		components: {
			DeptRole
		},
		data () {
			return {
				searchForm:{ktype:'username'},//查询
				//dialog
				visible: false,
				isShowModal: false,
				modalTitle:'添加',
				formData: {
					depts:[{dept_id:'',role_id:''}]
                },
				firstCascaderProps:{
					label: 'dept_name',
					value: 'id',
					children: 'children',
					emitPath: false,
					checkStrictly: true },
				//tree
				treeData: [],
				treeProps: {
					children: 'children',
					label: 'dept_name'
				},
				//table
				tabMapOptions: [
					{ label: '教师列表', key: 'CN' },
				],
				activeName: 'CN',
				tableData: [],
				page:{
					pageIndex:1,
					pageSize:10,
					total:0
				},
				multipleSelection:[],
				deptId:null,
				editRole:{},
				roleList:[],
			}
		},
		watch: {
			activeName(val) {
				this.$router.push(`${this.$route.path}?tab=${val}`)
			}
		},
		created() {
			// init the default selected tab
			const tab = this.$route.query.tab
			if (tab) {
				this.activeName = tab
			}
		},
		mounted() {
			this.getOrgList();
			this.getRoleList()
		},
		methods: {
			//tree
			getOrgList(){
				let _this = this
				this.$http.post(api.tea_deptList).then(res => {
					if (res.data && res.data.length > 0) {
						_this.deleteEmptyGroup(res.data).then(result => {
							_this.treeData = result
							if (result && result.length > 0) {
								_this.deptId = result[0].id
								_this.tabMapOptions[0].label = `${result[0].dept_name}`
								_this.getList()
							}
						})
					} else {
						this.$message.error(res.msg)
					}

				})
			},
			// 处理没有children的分组
			deleteEmptyGroup (treeData) {
				return new Promise(resolve => {
					function traversal (data) {
						data.map(item => {
							for (let info in item) {
								if (item['children']) {
									if (item['children'].length > 0) {
										traversal(item['children'])
									}
									if (item['children'].length == 0) {
										delete item['children']
									}
								}
							}
						})
					}

					traversal(treeData)
					resolve(treeData)
				})
			},
			getRoleList () {
				this.$http.post(api.deptRoleList).then(res => {
					this.roleList = res.data
				})
			},
			//table
			getList(){
				this.$http.post(api.deptUserList,{
					dept_id: this.deptId
				}).then(res => {
					this.tableData = res.data;
				})
			},
			handleNodeClick (data) {
				this.deptId = data.id
				this.tabMapOptions[0].label=`${data.dept_name}`
				this.getList()
			},
		
			handleModify(row){
				let _this = this
				this.isShowModal = true;
				this.modalTitle = '修改';
				if(row.role_id){
					row.role_id = String(row.role_id).split(',').map(Number);
				}
				row.depts = row.dept
				this.formData = row
				if(!this.formData.depts||this.formData.depts.length == 0){
					this.formData.depts = []
					this.formData = {..._this.formData}
				}
			},
			handleDel(row){
				this.$http.post(api.deptUserDel,{id:row.id}).then(res => {
					this.$message.success('删除成功')
					this.getList();
				})
			},
			handlePageChange (e) {
				this.page.pageIndex = e
				this.getList()
			},
			handleCascaderChange(e){
				console.log(1,e)
			},
			submitForm (formName) {
				let _this = this
				_this.$refs[formName].validate((valid) => {
					if (valid) {
						let params = {..._this.formData}
						params.dept_id = _this.deptId
						params.teacher_id = _this.formData.id
						_this.$http.post(api.deptUserSave,params).then(res => {
							this.$message.success('保存成功')
							this.getList();
							this.isShowModal = false;
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleSelectionChange(val) {
				let _this = this;
				_this.multipleSelection = val;
			},
			mutiDel(){
				let ids = ''
				if(this.multipleSelection&&this.multipleSelection.length>0){
					ids = this.multipleSelection.map((item, index) => {
						return item.id
					}).join(',')
					this.handleDel({id:ids})
				}else{
					this.$message.warning('请至少选择一条数据')
				}
			},
			showRole() {
				let _this = this
				if(this.multipleSelection&&this.multipleSelection.length>0){
					_this.editRole = {}
					_this.$refs.visiable_role.show()
				}else{
					this.$message.warning('请至少选择一条数据')
				}
				
			},
			saveRole(e){
				let _this = this
				let ids = ''
				ids = this.multipleSelection.map((item, index) => {
					return item.id
				}).join(',')
				let params = {
					dept_id: _this.deptId,
					teacher_id:ids,
					role_id: e,
				}
				this.$http.post(api.deptUserSave,params).then(res => {
					this.$message.success('保存成功')
					this.getList();
					this.$refs.visiable_role.handleCancel()
				})
			},
			addDept(){
				let _this = this
				console.log(this.formData.depts)
				this.formData.depts.push({dept_id:'',role_id:''})
				this.formData = {..._this.formData}

			},
            delDept(index){
				let _this = this
				this.formData.depts.splice(index,1)
				this.formData = {..._this.formData}

			}
		}
	}
</script>

<style scoped lang="less" type="text/less">
    .app-container {
        .treeContainer {
            height: 100%;
            background-color: #fff;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
            border: 1px solid  rgba(220,223,230,0.6);
            
            .treeTitle {
                height: 40px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #409eff;
                padding-left: 6px;
            }
        }
    }
</style>
